import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";

export const CA = "8Bdum5DBYXqqi5BeGej45vKVifELQM7pASUfysLTpump";

export const CopyCA = ({ size = "md" }) => {
  const [copied, setCopied] = useState(false);

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(CA);
      setCopied(true);
      toast.success("Contract address copied!", {
        description: "Paste it on Pump.fun or Raydium to ride the wave.",
      });
      setTimeout(() => setCopied(false), 1800);
    } catch (e) {
      toast.error("Copy failed. Long-press to copy manually.");
    }
  };

  const padding = size === "lg" ? "p-3 md:p-4" : "p-2.5 md:p-3";

  return (
    <div
      className={`flex items-center gap-2 gg-terminal rounded-xl ${padding} max-w-full`}
      data-testid="ca-container"
    >
      <span
        className="font-mono text-xs sm:text-sm md:text-base truncate flex-1 select-all text-[var(--jd-primary)]"
        title={CA}
        data-testid="ca-text"
      >
        {CA}
      </span>
      <button
        type="button"
        onClick={onCopy}
        aria-label="Copy contract address"
        data-testid="copy-ca-button"
        className="shrink-0 inline-flex items-center gap-1.5 bg-[var(--jd-secondary)] text-black rounded-lg px-3 py-2 font-display uppercase text-xs transition-transform hover:scale-105"
        style={{ filter: "drop-shadow(0 0 8px rgba(255,215,0,0.4))" }}
      >
        {copied ? <Check size={16} /> : <Copy size={16} />}
        <span className="hidden sm:inline">{copied ? "Copied" : "Copy"}</span>
      </button>
    </div>
  );
};

export default CopyCA;
